import gsap from 'gsap'
gsap.to('#loader', {
    opacity: 0,
    delay: 3.6,
    ease: 'expo.out',
    duration: 2.5,
    onComplete: () => {
        window.loader.style.display = 'none';
        gsap.to('#welcome', {
            opacity: 1,
            delay: 1,
            ease: 'expo.in',
            duration: 0.5,
            onStart: () => {
                gsap.to('.para', {
                    height: '50%',
                    duration: 3,
                    delay: 0.5,
                    ease: 'poweer4.out',

                })
            },
            onComplete: () => {
                gsap.to('#disor', {
                    opacity: 1,
                    duration: 2,
                    delay: 2,
                    ease: 'power4.out',

                })
            }
        })
    }
})

window.btn.addEventListener('click', () => {
    gsap.to('#welcome', {
        opacity: 0,
        duration: 1,
        onComplete: () => {
            gsap.to('#container , .title', {
                opacity: 1,
                duration: 1,
            })
        }
    })
})


window.explore.addEventListener('click', () => {
    console.log('done')
    gsap.to('#container,.title', {
        opacity: 0,
        duration: 1,
        onComplete: () => {
            gsap.to('#page', {
                opacity: 1,
                duration: 1,
            })
        }
    })
})
let h = document.querySelectorAll('.fire')
h.forEach((fire) => {
    fire.addEventListener('click', () => {
        console.log('ff')
        window.about.style.zIndex = 10;

        gsap.to('.fire', {
            opacity: 0,
            stagger: 0.3,
            duration: 0.5,
            onComplete: () => {
                gsap.to('#bigger', {
                    duration: 0,
                    ease: 'expo.out',
                    onComplete: () => {
                        gsap.to('#one,#three', {
                            opacity: 0,
                            duration: 0.3
                        })
                        gsap.to('#bigger', {
                            scaleX: 6,
                            scaleY: 3,
                            ease: 'power4.in',

                            duration: 0.7,
                            onComplete: () => {
                                gsap.to('#about', {
                                    opacity: 1,
                                    duration: 1.5,
                                    ease: 'power4.out',

                                })
                            }
                        })


                    }
                })
            }
        })
    })
})


window.back.addEventListener('click', () => {
    window.about.style.zIndex = -1;
    gsap.to('#about', {
        opacity: 0,
        duration: 1.5,
        onComplete: () => {
            gsap.to('#bigger', {
                scale: 1,
                ease: 'power4.in',
                duration: 1,
                onComplete: () => {
                    gsap.to('#bigger', {
                        duration: 1,
                        ease: 'expo.out',
                        onComplete: () => {
                            gsap.to('.fire', {
                                opacity: 1,
                                stagger: -0.3,
                                duration: 0.5,
                            })
                        }
                    })
                }
            })
            gsap.to('#one,#three', {
                opacity: 1,
                duration: 0.3
            })
        }
    })
})



window.expb.addEventListener('click', () => {

    gsap.to('#page', {
        opacity: 0,
        duration: 0.5
    })
    gsap.to('#projects', {
        opacity: 1,
        duration: 1
    })

})

gsap.set('#contactme', {
    x: '60vw',
    y: '-7%'
})
window.threes.addEventListener('click', () => {
    window.contactme.style.zIndex = 100;
    gsap.to('#page', {
        opacity: 0,
        duration: 0.5
    })
    gsap.to('#contactme', {
        opacity: 1,

        duration: 1.5
    })
    gsap.to('form', {
        display: 'flex',

        duration: 1.5
    })

})
window.backpro.addEventListener('click', () => {
    gsap.to('#page', {
        opacity: 1,
        duration: 0.5
    })
    gsap.to('#projects', {
        opacity: 0,
        zIndex: -3,
        duration: 1
    })


})

function backc() {

    gsap.to('#page', {
        opacity: 1,
        duration: 0.5
    })
    gsap.to('#contactme', {
        opacity: 0,

        duration: 0.5
    })
    gsap.to('form', {
        display: 'none',

        duration: 1.5
    })

}
let $bc = document.getElementById('backcont')
let form = document.getElementById('form')
$bc.addEventListener('click', backc)
form.addEventListener('submit', backc)